<template>
  <div>
    <div>
      <h6 class="mb-4 text-gray-800 font-normal">Δημιουργία νέου Project και επιλογή</h6>
      <ProjectForm
        :account-id="accountUuid"
        :client-uuid="clientRelationUuid"
        :default-project-name="defaultProjectName"
        :with-optional="['ownerUserId']"
        @created="selectProject"
      />
    </div>
    <div class="mt-16">
      <h6 class="mb-4 text-gray-800 font-normal">Επιλογή από υπάρχον Project</h6>
      <form @submit.prevent="selectProject(computedProjectUuid)">
        <BaseLayoutSpaced relaxed>
          <div class="flex -mx-4">
            <div class="flex-1 px-4">
              <ProjectFinder
                v-model="computedProjectUuid"
                prefetch
                :options="projects"
                :action="searchAction"
              />
            </div>
          </div>
          <div class="flex -mx-4">
            <div class="flex-1 px-4">
              <BaseButton primary> Επιλογή </BaseButton>
            </div>
          </div>
        </BaseLayoutSpaced>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import ProjectForm from '@/components/Projects/ProjectForm.vue';
import ProjectFinder from '@/components/Projects/ProjectFinder.vue';

export default {
  components: {
    ProjectForm,
    ProjectFinder,
  },

  props: {
    clientRelationUuid: {
      type: String,
      required: true,
    },
    accountUuid: {
      type: String,
      required: true,
    },
    clientUuid: {
      type: String,
      required: true,
    },
    projectUuid: {
      type: String,
      default: null,
    },
    defaultProjectName: {
      type: String,
      default: '',
    },
  },

  computed: {
    ...mapGetters('ui/accountProjects', ['projects']),
    computedProjectUuid: {
      get() {
        return this.projectUuid;
      },

      set(value) {
        this.$emit('update:project-uuid', value);
      },
    },
  },

  created() {
    const { defaultData } = this;

    if (typeof defaultData === 'object' && defaultData !== null) {
      Object.assign(this.data, defaultData);
    }
  },

  destroyed() {
    this.setIds([]);
  },

  methods: {
    ...mapActions('ui/accountProjects', ['fetchAccountProjectList']),
    ...mapMutations('ui/accountProjects', ['setIds']),
    searchAction(search) {
      const payload = {
        accountId: this.accountUuid,
        params: {
          filter: {
            search,
            account_relation_uuid: this.clientRelationUuid,
          },
        },
      };

      return this.fetchAccountProjectList(payload);
    },
    selectProject(projectUuid) {
      this.$emit('update:project-uuid', projectUuid);
      this.$emit('success');
    },
  },
};
</script>
